import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

const orangeIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-orange.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const FitBounds = ({ professionals }) => {
  const map = useMap();
  useEffect(() => {
    const markers = professionals
      .filter(p => p.approximate_lat && p.approximate_lng)
      .map(p => [p.approximate_lat, p.approximate_lng]);
    if (markers.length > 0) {
      const bounds = L.latLngBounds(markers);
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: 10 });
    }
  }, [professionals, map]);
  return null;
};

const DirectoryMap = ({ professionals, onProfessionalClick, height = '400px' }) => {
  const markersData = professionals.filter(p => p.approximate_lat && p.approximate_lng);
  const defaultCenter = [48.0, 12.0];

  if (markersData.length === 0) {
    return (
      <div 
        className="rounded-md border border-slate-200 bg-slate-50 flex items-center justify-center text-slate-400 text-sm"
        style={{ height }}
        data-testid="directory-map-empty"
      >
        Nessun professionista con posizione disponibile
      </div>
    );
  }

  return (
    <div className="rounded-md overflow-hidden border border-slate-200" style={{ height }} data-testid="directory-map">
      <MapContainer
        center={defaultCenter}
        zoom={5}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds professionals={markersData} />
        {markersData.map((prof) => (
          <Marker 
            key={prof.id} 
            position={[prof.approximate_lat, prof.approximate_lng]}
            icon={orangeIcon}
            eventHandlers={{
              click: () => onProfessionalClick && onProfessionalClick(prof.id)
            }}
          >
            <Popup>
              <div className="text-sm">
                <p className="font-semibold">{prof.company_name}</p>
                <p className="text-slate-500">{prof.location_city || prof.city}</p>
                {prof.distance_km !== undefined && (
                  <p className="text-orange-600 font-medium">{prof.distance_km} km</p>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default DirectoryMap;
